// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type Scope } from "~/hooks/useScope";
import { SET_INTEGRATION } from "./action";

export function canSetIntegration(scope: Scope): boolean {
  return scope.iamActions.includes(SET_INTEGRATION);
}
